/* istanbul ignore file */
export const legalDocs = 'legal-docs';
export const EULA_PDF = `${legalDocs}/eula_en-US.pdf`;
export const IFU_PDF = `${legalDocs}/ifu_en-US.pdf`;
